import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // Initialize gtag.js if not already done
    if (!window.dataLayer) {
      const gaId = import.meta.env?.VITE_GA_MEASUREMENT_ID;
      
      // Only initialize if GA ID is configured
      if (!gaId || gaId === 'your-google-analytics-id-here') {
        console.warn('Google Analytics: Measurement ID not configured');
        return;
      }

      // Load gtag.js script dynamically
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      script.async = true;
      document.head?.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag(...args) {
        window.dataLayer?.push(...args);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', gaId, {
        send_page_view: false // We'll send page views manually
      });
    }

    // Send page_view event on initial load and route changes
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: location?.pathname + location?.search,
        page_location: window.location?.href,
        page_title: document.title
      });
    }
  }, [location]);
}